<div matDialogTitle>{{ 'WARNING' | translate }}</div>
<div matDialogContent>
	<div class="message-content">{{ message | translate }}</div>
</div>
<div matDialogActions align="end">
	<button mat-button color="warn" matDialogClose="">
		{{ 'CLOSE' | translate }}
	</button>
</div>
